import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UiService } from 'app/shared/services/ui/ui.service';

export interface DialogData {
  text: string;
}

@Component({
  selector: 'app-open-dialog-confirm',
  templateUrl: './open-dialog-confirm.component.html',
  styleUrls: ['./open-dialog-confirm.component.scss']
})
export class OpenDialogConfirmComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OpenDialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private uiSrv: UiService
  ) { }

  ngOnInit(): void {
  }

}
